<template>
  <div class="row">
    <div class="col-20">
      <title-block
        :title="$t('view-Channels.title')"
        :subtitle="$t('view-Channels.title.subtitle')"
        :text="$t('view-Channels.title.text')"
      />
      <div class="row">
        <div class="col-20 order-2 col-lg-6 order-lg-1">
          <transition-group
            name="fade"
            tag="div"
            class="row"
          >
            <router-link
              v-for="item in $store.state.channels.items"
              :key="item.id"
              :to="{name: 'channels-show', params: { id: item.id }}"
              class="col-20 std-wrapper channel-link d-flex justify-content-between align-items-center"
            >
              <span
                :class="'social-ball ' + item.type_name"
              >
                <img :src="$publicPath + 'img/social/' + item.type_name + '-white.svg'">
              </span>
              <span class="mr-auto">
                {{ $t(item.type_name) }}
              </span>
              <span class="ok-markers">
                <img
                  v-if="item.verified"
                  :src="`${$publicPath}img/channels/ok3.svg`"
                >
                <img
                  v-else
                  :src="`${$publicPath}img/channels/not-ok.svg`"
                >
                <img
                  v-if="item.analytics_access"
                  :src="`${$publicPath}img/channels/ok3.svg`"
                >
                <img
                  v-else-if="item.analytics_data_status === 'unveryfied' || item.analytics_data_status === 'veryfied'"
                  :src="`${$publicPath}img/channels/ok.svg`"
                >
                <img
                  v-else
                  :src="`${$publicPath}img/channels/not-ok.svg`"
                >
              </span>
            </router-link>
          </transition-group>
          <div class="row">
            <std-button
              :route-link="{name: 'channels-add'}"
              add-class="col-20 std-wrapper"
              type="B"
              :title="$t('view-Channels.add-button')"
            />
          </div>
        </div>
        <div class="col-20 order-1 col-lg-13 order-lg-2 offset-lg-1">
          <div class="row">
            <div class="col-20">
              <transition
                name="fade"
                @before-leave="makeAbsolute"
              >
                <router-view :key="$route.params.id" />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeMount () {
    this.$store.dispatch('channels/getList').catch(() => {})
    this.$store.dispatch('channelsTypes/get').catch(() => {})
    this.$store.dispatch('thematicCategories/get').catch(() => {})
  }
}
</script>

<style lang="scss" scoped>
  .channel-link {
    color: black;
    background-color: white;
    text-transform: uppercase;
    font-size: 0.75rem;
    &:hover {
      text-decoration: none;
      color: inherit;
      border-color: $warning;
    }
    &.router-link-active {
      border-color: $warning;
    }
  }
  .social-ball {
    margin-left: 0.813rem;
    margin-right: 1.438rem;
  }
  .ok-markers {
    img {
      max-height: 14px;
      margin-left: 0.5rem;
    }
  }
</style>
